import axios from 'axios';
import constants from '../../assets/constants';
// import { io } from "socket.io-client";

export default {
  // namespaced: true,
  state: {
    connected: false,
    truckOffRentOrders: {
      OffOrders: [],
      offRentOrdersAR: [],
      OrdersTransport: [],
      allOrdersRecon: [],
      allOrdersService: [],
      shippingOrdersTransport: [],
    },
    truckOrders: {
      Orders: [],
      currentOrderNotes: [],
      allAssignedOrders: [],
      allOpenContractsAR: [],
      currentNoteOrder: {},
    },
    truckClaims: {
      allOpenClaimsAR: [],
    },
    truckOrdersCR: {
      allRecentDeliveries: [],
    },
    truckAuctionSales: {
      allAtAuction: [],
    },
    truckTitles: {
      titles: [],
    },
    overviewTrucks: {
      trucks: [],
    },
    creditMemos: {
      allCreditMemos: [],
    }
  },
  getters: {
    // -  On Rents
    getAllOrders: (state) => state.truckOrders.Orders,
    getAllAssignedOrders: (state) => state.truckOrders.allAssignedOrders,
    getCurrentOrderNotes: (state) => state.truckOrders.currentOrderNotes,
    getCurrentNoteOrder: (state) => state.truckOrders.currentNoteOrder,
    // - Off Rents
    getAllOffRentOrders: (state) => state.truckOffRentOrders.OffOrders,
    getOrdersForTransport: (state) => state.truckOffRentOrders.OrdersTransport,
    getShippingForTransport: (state) => state.truckOffRentOrders.shippingOrdersTransport,
    // - Accounts Receivable
    getAllOpenContractsAR: (state) => state.truckOrders.allOpenContractsAR,
    getOffRentContractsAR: (state) => state.truckOffRentOrders.offRentOrdersAR,
    getAllOpenClaimsAR: (state) => state.truckClaims.allOpenClaimsAR,
    //  - Recon
    getAllReconOrders: (state) => state.truckOffRentOrders.allOrdersRecon,
    //  - Service
    getAllServiceOrders: (state) => state.truckOffRentOrders.allOrdersService,
    // - Client Relations
    getAllRecentDeliveries: (state) => state.truckOrdersCR.allRecentDeliveries,
    // - Sales
    getSalesAtAuction: (state) => state.truckAuctionSales.allAtAuction,
    // - Titles
    getTitles: (state) => state.truckTitles.titles,
    // - Overview Trucks
    getOverviewTrucks: (state) => state.overviewTrucks.trucks,
    // - Credit Memos
    getAllCreditMemos: (state) => state.creditMemos.allCreditMemos,
  },
  mutations: {
    setSocket(state, socket) {
      state.socket = socket;
    },
    setConnected(state, connected) {
      state.connected = connected;
    },
    setMessage(state, message) {
      state.message = message;
    },
    // -  On Rents
    setCurrentOrderNotes(state, payload) {
      state.truckOrders.currentOrderNotes = payload;
    },
    setCurrentNoteOrder(state, payload) {
      state.truckOrders.currentNoteOrder = payload;
    },
    //  - Sockets
    // * OnBoarding
    SOCKET_onBoardingCardsEmit(state, payload) {
      state.truckOrders.Orders = payload;
    },
    SOCKET_onboardingUpdated(state, updatedOrder) {
      const idx = state.truckOrders.Orders.findIndex(
        o => parseInt(o.FormHistoryID) === parseInt(updatedOrder.FormHistoryID)
      );
      if (idx !== -1) {
        state.truckOrders.Orders.splice(idx, 1, {
          ...state.truckOrders.Orders[idx],
          ...updatedOrder
        });
      } else {
        state.truckOrders.Orders.push(updatedOrder);
      }
    },
    // * OffBoarding
    SOCKET_offBoardingCardsEmit(state, payload) {
      state.truckOffRentOrders.OffOrders = payload;
    },
    SOCKET_offboardingUpdated(state, updatedOffOrder) {
      const idx = state.truckOffRentOrders.OffOrders.findIndex(
        o => parseInt(o.FormHistoryID) === parseInt(updatedOffOrder.FormHistoryID)
      );
      if (idx !== -1) {
        state.truckOffRentOrders.OffOrders.splice(idx, 1, {
          ...state.truckOffRentOrders.OffOrders[idx],
          ...updatedOffOrder
        });
      } else {
        state.truckOffRentOrders.OffOrders.push(updatedOffOrder);
      }
    },
    // * Transport
    SOCKET_transportCardsRefreshEmit(state, payload) {
      state.truckOffRentOrders.OrdersTransport = payload;
    },
    SOCKET_transportUpdated(state, updatedTransport) {
      const updatedFH = Number(updatedTransport.FormHistoryID);
      const hasCO = Object.prototype.hasOwnProperty.call(updatedTransport, 'CarrierOrderID');
      const updatedCO = updatedTransport.CarrierOrderID ?? null;

      let foundMatch = false;

      state.truckOffRentOrders.OrdersTransport = state.truckOffRentOrders.OrdersTransport.map(o => {
        const sameForm = Number(o.FormHistoryID) === updatedFH;

        // CASE 1: CarrierOrderID NOT provided → update ALL with same FormHistoryID
        if (!hasCO) {
          if (sameForm) {
            foundMatch = true;
            return { ...o, ...updatedTransport };
          }
          return o;
        }

        // CASE 2: CarrierOrderID is NULL → only update NULL ones
        if (updatedCO === null) {
          const currentCO = o.CarrierOrderID ?? null;
          if (sameForm && currentCO === null) {
            foundMatch = true;
            return { ...o, ...updatedTransport };
          }
          return o;
        }

        // CASE 3: CarrierOrderID has value → exact match only
        const currentCO = o.CarrierOrderID ?? null;
        if (sameForm && currentCO === updatedCO) {
          foundMatch = true;
          return { ...o, ...updatedTransport };
        }

        return o;
      });

      // If nothing matched, add it (optional, depending on your logic)
      if (!foundMatch) {
        state.truckOffRentOrders.OrdersTransport.push(updatedTransport);
      }
    },
    SOCKET_transportBulkUpdated(state, updates) {
      const { FormHistoryID, rows } = updates;

      const formHistoryID = parseInt(FormHistoryID);

      // 1. REMOVE all existing rows for this FormHistoryID
      state.truckOffRentOrders.OrdersTransport =
        state.truckOffRentOrders.OrdersTransport.filter(
          o => parseInt(o.FormHistoryID) !== formHistoryID
        );

      // 2. ADD the fresh rows
      if (rows && rows.length > 0) {
        state.truckOffRentOrders.OrdersTransport.push(...rows);
      }
    },
    SOCKET_transportRemoved(state, removedTransport) {
      state.truckOffRentOrders.OrdersTransport = state.truckOffRentOrders.OrdersTransport.filter(o => 
        o.FormHistoryID !== removedTransport.FormHistoryID && o.FormType.includes('On', 'Off', 'Trade On', 'Trade Off')
      );
    },
    SOCKET_shippingCardsRefreshEmit(state, payload) {
      state.truckOffRentOrders.shippingOrdersTransport = payload;
    },
    SOCKET_shippingUpdated(state, updatedShipping) {
      const idx = state.truckOffRentOrders.shippingOrdersTransport.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedShipping.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckOffRentOrders.shippingOrdersTransport.splice(idx, 1, {
          ...state.truckOffRentOrders.shippingOrdersTransport[idx],
          ...updatedShipping
        });
      } else {
        state.truckOffRentOrders.shippingOrdersTransport.push(updatedShipping);
      }
    },
    // * Accounts Receivable
    SOCKET_arOffRentCardsRefreshEmit(state, payload) {
      state.truckOffRentOrders.offRentOrdersAR = payload;
    },
    SOCKET_arOffUpdated(state, updatedAROff) {
      const idx = state.truckOffRentOrders.offRentOrdersAR.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedAROff.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckOffRentOrders.offRentOrdersAR.splice(idx, 1, {
          ...state.truckOffRentOrders.offRentOrdersAR[idx],
          ...updatedAROff
        });
      } else {
        state.truckOffRentOrders.offRentOrdersAR.push(updatedAROff);
      }
    },
    SOCKET_arOffBulkUpdated(state, updates) {
      const { FormHistoryID, rows } = updates;

      const formHistoryID = parseInt(FormHistoryID);

      // 1. REMOVE all existing rows for this FormHistoryID
      state.truckOffRentOrders.offRentOrdersAR =
        state.truckOffRentOrders.offRentOrdersAR.filter(
          o => parseInt(o.FormHistoryID) !== formHistoryID
        );

      // 2. ADD the fresh rows if exists
      if (rows && rows.length > 0) {
        state.truckOffRentOrders.offRentOrdersAR.push(...rows);
      }
    },
    SOCKET_arOpenCardsRefreshEmit(state, payload) {
      state.truckOrders.allOpenContractsAR = payload;
    },
    SOCKET_arUpdated(state, updatedAROn) {
      const idx = state.truckOrders.allOpenContractsAR.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedAROn.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckOrders.allOpenContractsAR.splice(idx, 1, {
          ...state.truckOrders.allOpenContractsAR[idx],
          ...updatedAROn
        });
      } else {
        state.truckOrders.allOpenContractsAR.push(updatedAROn);
      }
    },
    SOCKET_arBulkUpdated(state, updates) {
      const { FormHistoryID, rows } = updates;

      const formHistoryID = parseInt(FormHistoryID);

      // 1. REMOVE all existing rows for this FormHistoryID
      state.truckOrders.allOpenContractsAR =
        state.truckOrders.allOpenContractsAR.filter(
          o => parseInt(o.FormHistoryID) !== formHistoryID
        );

      // 2. ADD the fresh rows if exists
      if (rows && rows.length > 0) {
        state.truckOrders.allOpenContractsAR.push(...rows);
      }
    },
    SOCKET_arClaimsCardsRefreshEmit(state, payload) {
      state.truckClaims.allOpenClaimsAR = payload;
    },
    SOCKET_arClaimsUpdated(state, updatedARClaims) {
      const idx = state.truckClaims.allOpenClaimsAR.findIndex(
        o => parseInt(o.TagClaimsID) === parseInt(updatedARClaims.TagClaimsID)
      );
      if (idx !== -1) {
        state.truckClaims.allOpenClaimsAR.splice(idx, 1, {
          ...state.truckClaims.allOpenClaimsAR[idx],
          ...updatedARClaims
        });
      } else {
        state.truckClaims.allOpenClaimsAR.push(updatedARClaims);
      }
    },
    // * Client Relations
    SOCKET_crCardsRefreshEmit(state, payload) {
      state.truckOrdersCR.allRecentDeliveries = payload;
    },
    // * Recon
    SOCKET_reconCardsRefreshEmit(state, payload) {
      state.truckOffRentOrders.allOrdersRecon = payload;
    },
    SOCKET_reconUpdated(state, updatedRecon) {
      const idx = state.truckOffRentOrders.allOrdersRecon.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedRecon.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckOffRentOrders.allOrdersRecon.splice(idx, 1, {
          ...state.truckOffRentOrders.allOrdersRecon[idx],
          ...updatedRecon
        });
      } else {
        state.truckOffRentOrders.allOrdersRecon.push(updatedRecon);
      }
    },
    SOCKET_reconBulkUpdated(state, updates) {
      const { FormHistoryID, rows } = updates;

      const formHistoryID = parseInt(FormHistoryID);

      // 1. REMOVE all existing rows for this FormHistoryID
      state.truckOffRentOrders.allOrdersRecon =
        state.truckOffRentOrders.allOrdersRecon.filter(
          o => parseInt(o.FormHistoryID) !== formHistoryID
        );

      // 2. ADD the fresh rows
      if (rows && rows.length > 0) {
        state.truckOffRentOrders.allOrdersRecon.push(...rows);
      }
    },
    SOCKET_reconRemoved(state, removedRecon) {
      state.truckOffRentOrders.allOrdersRecon = state.truckOffRentOrders.allOrdersRecon.filter(o => 
        o.TagHistoryID !== removedRecon.TagHistoryID
      );
    },
    // * Service
    SOCKET_serviceCardsRefreshEmit(state, payload) {
      state.truckOffRentOrders.allOrdersService = payload;
    },
    SOCKET_serviceUpdated(state, updatedService) {
      const idx = state.truckOffRentOrders.allOrdersService.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedService.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckOffRentOrders.allOrdersService.splice(idx, 1, {
          ...state.truckOffRentOrders.allOrdersService[idx],
          ...updatedService
        });
      } else {
        state.truckOffRentOrders.allOrdersService.push(updatedService);
      }
    },
    SOCKET_serviceBulkUpdated(state, updates) {
      const { FormHistoryID, rows } = updates;

      const formHistoryID = parseInt(FormHistoryID);

      // 1. REMOVE all existing rows for this FormHistoryID
      state.truckOffRentOrders.allOrdersService =
        state.truckOffRentOrders.allOrdersService.filter(
          o => parseInt(o.FormHistoryID) !== formHistoryID
        );

      // 2. ADD the fresh rows
      if (rows && rows.length > 0) {
        state.truckOffRentOrders.allOrdersService.push(...rows);
      }
    },
    SOCKET_serviceRemoved(state, removedService) {
      state.truckOffRentOrders.allOrdersService = state.truckOffRentOrders.allOrdersService.filter(o => 
        o.TagHistoryID !== removedService.TagHistoryID
      );
    },
    // * Sales
    SOCKET_salesCardsRefreshEmit(state, payload) {
      state.truckAuctionSales.allAtAuction = payload;
    },
    SOCKET_salesUpdated(state, updatedSales) {
      const idx = state.truckAuctionSales.allAtAuction.findIndex(
        o => parseInt(o.TagHistoryID) === parseInt(updatedSales.TagHistoryID)
      );
      if (idx !== -1) {
        state.truckAuctionSales.allAtAuction.splice(idx, 1, {
          ...state.truckAuctionSales.allAtAuction[idx],
          ...updatedSales
        });
      } else {
        state.truckAuctionSales.allAtAuction.push(updatedSales);
      }
    },
    SOCKET_salesRemoved(state, removedSales) {
      state.truckAuctionSales.allAtAuction = state.truckAuctionSales.allAtAuction.filter(o => 
        o.TagHistoryID !== removedSales.TagHistoryID
      );
    },
    // * Titles
    SOCKET_titlesCardsRefreshEmit(state, payload) {
      state.truckTitles.titles = payload;
    },
    // * Overview
    SOCKET_overviewCardsRefreshEmit(state, payload) {
      state.overviewTrucks.trucks = payload;
    },
    // * Credit Memos
    SOCKET_creditMemosRefreshEmit(state, payload) {
      state.creditMemos.allCreditMemos = payload;
    }
  },
  actions: {
    // connect({ commit }) {
    //   localStorage.debug = '*';
    //   const socket = io(constants.BASE_URL, {
    //     withCredentials: true,
    //     autoConnect: false,
    //     query: {
    //       token: localStorage.getItem('token') ? localStorage.getItem('token').split(' ')[1] : '',
    //     },
    //   });
    //   socket.on("connect", () => {
    //     commit("setConnected", true);
    //   });
  
    //   socket.on("disconnect", () => {
    //     commit("setConnected", false);
    //   });

    //   // Listen for custom socket events and commit to store
    //   // socket.on("onBoardingCardsRefresh", (payload) => {
    //   //   commit("SOCKET_onBoardingCardsEmit", payload);
    //   // });
    //   // socket.on("offBoardingCardsRefresh", (payload) => {
    //   //   commit("SOCKET_offBoardingCardsEmit", payload);
    //   // });
    //   // socket.on("transportCardsRefresh", (payload) => {
    //   //   commit("SOCKET_TransportCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("shippingCardsRefresh", (payload) => {
    //   //   commit("SOCKET_shippingCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("arOffRentCardsRefresh", (payload) => {
    //   //   commit("SOCKET_arOffRentCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("arOpenCardsRefresh", (payload) => {
    //   //   commit("SOCKET_arOpenCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("arClaimsCardsRefresh", (payload) => {
    //   //   commit("SOCKET_arClaimsCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("reconCardsRefresh", (payload) => {
    //   //   commit("SOCKET_reconCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("salesCardsRefresh", (payload) => {
    //   //   commit("SOCKET_salesCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("titlesCardsRefresh", (payload) => {
    //   //   commit("SOCKET_titlesCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("overviewCardsRefresh", (payload) => {
    //   //   commit("SOCKET_overviewCardsRefreshEmit", payload);
    //   // });
    //   // socket.on("creditMemosRefresh", (payload) => {
    //   //   commit("SOCKET_creditMemosRefreshEmit", payload);
    //   // });

    //   // Save socket reference
    //   commit("setSocket", socket);
    //   socket.connect();
    // },
    disconnect({ state }) {
      if (state.socket) {
        state.socket.disconnect();
      }
    },
    // -  On Rents
    fetchNotes({ commit }, formHistoryID) {
      let formHistID;
      let unitNum;
      if (formHistoryID.form) {
        formHistID = formHistoryID.form;
        unitNum = formHistoryID.unit;
      } else {
        formHistID = formHistoryID;
        unitNum = 'Ignore';
      }
      // console.log('fetching notes for formHistoryID: ', formHistID, ' and unitNum: ', unitNum);
      axios
        .get(`${constants.BASE_URL}/api/orders/${formHistID}/notes/${unitNum}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((res) => {
          commit('setCurrentOrderNotes', res.data);
        })
        .catch((error) => {
          console.log('error getting notes: ', error);
        });
    },
    fetchCurrentNoteOrder({ commit }, payload) {
      /*
      One of the locations for the root of this data:
         "CALL getApprovedTransport();",
      */

      commit('setCurrentNoteOrder', payload);
    },
    fetchAllUnitNotes({ commit }, unitNum) {
      axios
        .get(`${constants.BASE_URL}/api/all-unit-notes/${encodeURIComponent(unitNum)}`, {
          headers: {
            Authorization: localStorage.getItem('token'),
          },
        })
        .then((res) => {
          commit('setCurrentOrderNotes', res.data);
        })
        .catch((error) => {
          console.log('error getting notes: ', error);
        });
    }
  },
};
